import { gql } from "graphql-request";

export const GET_AGENCY_POINTS_CONVERT_QUOTE = gql`
  query getAgencyPointsConvertQuote {
    getAgencyPointsConvertQuote {
      status
      error
      data
    }
  }
`;

// ⚠️ The gateway spreads `body.variables` raw into the worker: the GraphQL
// variable name MUST match the argument name (`$quantityCoins` -> `quantityCoins`).
export const CONVERT_AGENCY_POINTS_TO_COINS = gql`
  mutation convertAgencyPointsToCoins($quantityCoins: Int!) {
    convertAgencyPointsToCoins(quantityCoins: $quantityCoins) {
      status
      error
      data
    }
  }
`;
